var _a;
import { EOrderBookType } from "@adapters/features/OrderBook/Presenters/action-interface/OrderBook";
import { combineReducers } from "redux";
import createNamedWrapperReducer from "../Markets/Common/Reducers/wrapperReducer";
import EqOrderBookReducer from "./Reducers/equity";
import MFOrderBookReducer from "./Reducers/mutualFund";
import NFOOrderBookReducer from "./Reducers/nfo";
import IPOOrderBookReducer from "./Reducers/ipo";
import INcdPOOrderBookReducer from "./Reducers/ncdipo";
import EqSipOrderBookReducer from "./Reducers/equity/eqSip";
import MFSipOrderBookReducer from "./Reducers/mutualFund/mfSip";
import MFOrderBookHoldingsReducer from "./Reducers/mutualFund/mfHoldings";
import CoOrderBookReducer from "./Reducers/commodity";
export default combineReducers((_a = {},
    _a[EOrderBookType.OEQ] = createNamedWrapperReducer(EqOrderBookReducer, EOrderBookType.OEQ),
    _a[EOrderBookType.CEQ] = createNamedWrapperReducer(EqOrderBookReducer, EOrderBookType.CEQ),
    _a[EOrderBookType.NFO] = createNamedWrapperReducer(NFOOrderBookReducer, EOrderBookType.NFO),
    _a[EOrderBookType.OCO] = createNamedWrapperReducer(CoOrderBookReducer, EOrderBookType.OCO),
    _a[EOrderBookType.CCO] = createNamedWrapperReducer(CoOrderBookReducer, EOrderBookType.CCO),
    _a[EOrderBookType.IPO] = createNamedWrapperReducer(IPOOrderBookReducer, EOrderBookType.IPO),
    _a[EOrderBookType.NCDIPO] = createNamedWrapperReducer(INcdPOOrderBookReducer, EOrderBookType.NCDIPO),
    _a[EOrderBookType.MF] = createNamedWrapperReducer(MFOrderBookReducer, EOrderBookType.MF),
    _a[EOrderBookType.OMFH] = createNamedWrapperReducer(MFOrderBookHoldingsReducer, EOrderBookType.OMFH),
    _a[EOrderBookType.CMFH] = createNamedWrapperReducer(MFOrderBookHoldingsReducer, EOrderBookType.CMFH),
    _a[EOrderBookType.EQSIP] = createNamedWrapperReducer(EqSipOrderBookReducer, EOrderBookType.EQSIP),
    _a[EOrderBookType.MFSIP] = createNamedWrapperReducer(MFSipOrderBookReducer, EOrderBookType.MFSIP),
    _a));
